import { gql } from '@apollo/client'

import { viewFragment } from 'js/magazine-issue/lib/fragments'

export const MAGAZINE_ISSUE_VIEW = gql`
    query MagazineIssueView($guid: String!) {
        entity(guid: $guid) {
            guid
            ${viewFragment}
        }
    }
`
